let constSpeakerRoles: any = {
  startPlayOnTimeCheckRef: false,
  playerModeRef: 'video',
  playerTimeRef: 0,
  isHandlePlayerToTimeEmit: false,
  getRoleSplitTipTimer: null,
  speakerSummaryRef: false,
};

const setSpeakerRolesData = (key, val) => {
  constSpeakerRoles[key] = val;
};

const getSpeakerRolesData = (key) => {
  return constSpeakerRoles[key];
};

const destroySpeakerRolesData = () => {
  constSpeakerRoles = {};
};

export { setSpeakerRolesData, getSpeakerRolesData, destroySpeakerRolesData };
